import React from 'react';
import { useStore } from 'react-redux';
import { useHydrateAtoms } from '@exodus/jotai/utils';
import { Provider as JotaiProvider } from '@exodus/jotai';
import defaultStore from '../core/store.js';
import { adaptersAtom, exodusAtom, reduxAtom, selectorsAtom } from '../core/atoms.js';
export function Provider({ exodus, adapters, selectors, store = defaultStore, children, }) {
    const reduxStore = useStore();
    useHydrateAtoms([
        [exodusAtom, exodus],
        [adaptersAtom, adapters],
        [reduxAtom, reduxStore],
        [selectorsAtom, selectors],
    ], { store });
    return React.createElement(JotaiProvider, { store: store }, children);
}
